/* eslint-disable @typescript-eslint/no-explicit-any */
function enumKeys(_enum) {
  return Object.keys(_enum).filter(key => isNaN(Number(key)));
}
function enumValues(_enum) {
  return enumKeys(_enum).map(key => _enum[key]);
}
function enumEntries(_enum) {
  return enumKeys(_enum).map(key => [key, _enum[key]]);
}
export const Enum = {
  keys: enumKeys,
  values: enumValues,
  entries: enumEntries
};